import { defineMessages, useIntl } from 'react-intl';

const m = defineMessages({
  nameIsRequired: {
    id: 'Problematic.Validation.Name.IsRequired',
    defaultMessage: 'Le nom est requis',
  },
});

export const useProblematicValidations = () => {
  const { formatMessage } = useIntl();

  const validations = {
    name: (value: string) => Boolean(value) || formatMessage(m.nameIsRequired),
  };

  return validations;
};
